import _JSXStyle from "styled-jsx/style";
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
export const Center = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    dataTest,
    children,
    position
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    ref: ref,
    className: "jsx-498096601" + " " + (cx('center', className, position) || "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "jsx-498096601" + " " + "center-inner-content"
  }, children), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "498096601"
  }, [".center.jsx-498096601{width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:space-around;-webkit-justify-content:space-around;-ms-flex-pack:space-around;justify-content:space-around;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;pointer-events:none;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}", ".center.top.jsx-498096601{-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;}", ".center.bottom.jsx-498096601{-webkit-align-items:flex-end;-webkit-box-align:flex-end;-ms-flex-align:flex-end;align-items:flex-end;}", ".center-inner-content.jsx-498096601{pointer-events:all;}"]));
});
Center.displayName = 'Center';
Center.defaultProps = {
  dataTest: 'dhis2-uicore-centeredcontent',
  position: 'middle'
};
Center.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataTest: PropTypes.string,

  /** Vertical alignment */
  position: PropTypes.oneOf(['top', 'middle', 'bottom'])
};